import type { ReportConfig } from '../types/panelConfig';

/**
 * Rapor kimligi firmadan bagimsizdir: dokuz market firmasi ayni 34 raporluk
 * sozlugu paylasir ve rapor kodu `firmaOneki * 1000 + sonek` seklindedir
 * (Gizova 990015, Huzur 998015- ikisi de "Kategori Bazinda Satis").
 * Bu yuzden ekran KOD degil SONEK ile arar.
 *
 * Kod, `/^\d+$/` ile ONDALIKLI, TAM SAYI BASAMAKLARINDAN ibaret mi diye
 * KATI kontrol edilir - `Number()` coercion'ina guvenilmez. Aksi halde
 * `Number('')` ve `Number(' ')` 0'a, `Number('0x3E7')` hex coercion ile
 * 999'a esitlenir ve gecersiz kodlar yanlislikla gecerli sayilir.
 *
 * CONTROLLER RULING F4: sonek kimliginin firmalar arasi evrenselligi bir
 * GARANTI degil GOZLEMDIR - sonek 1-34 arasinda tutuyor, ama 35'te kirildi
 * (`995035` baska bir firmada "Acik Hesaplar", bizim "Satis Kanali Ozeti"
 * ile hicbir ilgisi yok). Bu yuzden opsiyonel `beklenenAd` parametresi var:
 * verildiginde eslesen raporun `name`'i birebir tutmazsa `undefined` doner.
 * Adsiz cagrida (parametre atlanirsa) eski davranis aynen surer. Boylece
 * ileride baska bir sonek carpismasi "sessiz cop" (yanlis raporun verisini
 * basmak) yerine "gizli blok" (o ekran bolumu sessizce kaybolur) uretir.
 */
export function raporBul(
  reports: ReportConfig[],
  sonek: number,
  beklenenAd?: string,
): ReportConfig | undefined {
  const bulunan = reports.find((r) => {
    if (!/^\d+$/.test(r.code)) return false;
    return Number(r.code) % 1000 === sonek;
  });
  if (bulunan && beklenenAd !== undefined && bulunan.name !== beklenenAd) {
    return undefined;
  }
  return bulunan;
}

/** Rapor bulunamazsa, adi (verildiyse) tutmazsa veya sourceId yoksa undefined - cagiran blok gizlenir. */
export function sourceIdBul(
  reports: ReportConfig[],
  sonek: number,
  beklenenAd?: string,
): number | undefined {
  return raporBul(reports, sonek, beklenenAd)?.sourceId ?? undefined;
}
